// Namespaced as `companyApproval` by the locale registrar (camelCase of the
// file name). The matching PHP lang file carries the server-side messages; the
// keys here are the ones the screen renders itself.
export default {
  title: 'Company Approval',
  button: 'Company Approval',
  copy_table: 'Copy table',
  copied: 'Table copied',
  copy_failed: 'Could not copy the table',
  copy_hint: 'The table is copied with its formatting, so it pastes into Word or an email as a real table.',
  edit_hint: 'The figures are computed from the claim; any cell or column name can be corrected before copying.',
  load_failed: 'Could not load the approval data',

  // Mailing the company
  mail_button: 'Mail the company',
  mail_title: 'Mail the company',
  mail_to: 'Recipients',
  mail_to_hint: 'The client\'s employee addresses. Type an address and press Enter to add another.',
  mail_subject: 'Subject',
  mail_body: 'Message',
  mail_body_hint: 'The message can be edited freely before sending.',
  mail_send: 'Send',
  mail_sent: 'The message has been sent',
  mail_failed: 'Could not send the message',
  mail_needs_recipient: 'Add at least one recipient',
  mail_needs_subject: 'Write a subject',
  mail_confirm: 'This really sends the message to {count} address(es). Continue?',
  client: 'Client',

  export_excel: 'Export Excel',
  exported: 'File downloaded',

  mail_attachments: 'Attachments',
  mail_add_attachments: 'Add files',
  mail_attachments_hint: 'Pick several at once, or press again to add more. Up to 10 files, 10 MB each and 15 MB in total.',
  mail_too_many: 'At most {max} files',
  mail_attachments_too_large: 'The attachments exceed {max} MB',
  mail_tokens_hint: 'Inserted as written and filled from the claim when sent. Or tap Ctrl three times inside the body.',

  add_column: 'New column',
  new_column: 'New column',
  columns_hint: 'A field is added as a column with its name and value. Reorder or remove columns with the buttons above each one.',
  save_settings: 'Save settings',
  load_settings: 'Restore saved',
  settings_saved: 'Settings saved',
  settings_loaded: 'Saved settings restored',
  settings_save_failed: 'Could not save the settings',
  reset_settings: 'Reset',
  reset_confirm: 'This drops every edit and goes back to the default. Continue?',
  settings_reset: 'Back to the default',

  move_start: 'Move right',
  move_end: 'Move left',
  remove_column: 'Remove column',

  palette_title: 'Fields',
  palette_search: 'Search for a field…',
  palette_empty: 'No matching field',
  palette_hint: '↑ ↓ to move · Enter to insert · Esc to close',

  columns: {
    pay_type: 'Payment type',
    remaining: 'Remaining',
    discount_percent: 'Discount %',
    previous_paid: 'Previously paid',
    paid: 'Paid amount',
    amount_after_discount: 'Claim amount after discount',
    base_amount: 'Base amount',
    pay_date: 'Payment date',
    assign_date: 'Assign date',
    claim_number: 'Claim number',
    transferor: 'Transferor name'
  }
};
